@if (editInline()) {
    <se-letter-cell-editor-inline
        [letterFormControl]="formControl"
        [notAdmissibleChars]="notAdmissibleChars()"
        [cellReady]="cellReady()"
    >
    </se-letter-cell-editor-inline>
} @else {
    <se-letter-cell-editor-popup
        [letterFormControl]="formControl"
        [notAdmissibleChars]="notAdmissibleChars()"
        [width]="cellWidth()"
        [cellReady]="cellReady()"
    >
    </se-letter-cell-editor-popup>
}
